import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import Button from 'flow/components/ui-components/Button';
import { VIDEO_DARK_BRAND_CLASS } from 'flow/actions/brandingV2-actions';
import { selectShouldShowActivateChatHistoryButton } from 'flow/selectors/meeting-selectors';
import ActivateChatHistoryModal from './ActivateChatHistoryModal';

type Props = {
    meetingName: string;
    videoDark?: boolean;
};

const ActivateChatHistoryButton: React.FC<Props> = ({
    meetingName,
    videoDark = false,
}) => {
    const { i18next } = useAppContext();
    const [showActivateModal, setShowActivateModal] = useState(false);

    const showButton = useAppSelector(
        selectShouldShowActivateChatHistoryButton,
    );

    return (
        <>
            {showButton && (
                <div className="py-2">
                    <Button
                        color="primary"
                        className={twMerge(
                            'h-12 w-full !rounded-xl',
                            videoDark &&
                                `${VIDEO_DARK_BRAND_CLASS} hover:!brighten-10`,
                        )}
                        onClick={() => setShowActivateModal(true)}
                    >
                        {i18next.t('call.canvas.chat.activate_chat_history')}
                    </Button>
                </div>
            )}
            {showActivateModal && (
                <ActivateChatHistoryModal
                    meetingName={meetingName}
                    onClose={() => setShowActivateModal(false)}
                />
            )}
        </>
    );
};

export default ActivateChatHistoryButton;
